<template>
	<div
		class="member-status sgnl-flex sgnl-align-center sgnl-gap-4 sgnl-paragraph-s-regular sgnl-text-color-secondary"
	>
		<DotMark16
			class="sgnl-flex-shrink-0"
			:class="isPending ? 'sgnl-icon-color-warning' : 'sgnl-icon-color-success'"
		/>
		<span>{{ isPending ? "Invitation Sent" : "Joined" }}</span>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import DotMark16 from "@carbon/icons-vue/es/dot-mark/16";
import { OrganizationUserStatus } from "@/types/api/organizations";

export default defineComponent({
	name: "MemberStatusBadge",
	components: { DotMark16 },
	props: {
		status: { type: String as PropType<OrganizationUserStatus>, required: true },
	},
	computed: {
		isPending(): boolean {
			return this.status === "Pending";
		},
	},
});
</script>
